import { isEmpty, each, upperFirst } from 'lodash-es'

/**
 * @function processErrors
 * @desc Process errorsDTO array included in errorDTO.
 *       Not a generic function, done for bulk creations (gateways and end-devices).
 * @param {object|string}  errors  - An error DTO with errors attribute
 * @return {string} A flat array of errors (one title, a list of errors).
 */
const processErrors = errors => {
  // If errors is a string return it
  let errorDTO = errors
  if (typeof errors === 'string') return errors

  // No errors array, return root message
  if (isEmpty(errorDTO.errors)) return [{ details: [errorDTO.message], type: 'error' }]

  // Will contains errors as object:
  // - title: main error message
  // - details: array of secondary error messages
  const processedErrors = []

  // Loop through errors array
  each(errorDTO.errors, (error) => {
    let errorType = 'error'
    let errorPrefix = '[ERROR]'
    let errorDetails = []

    // Loop through errors details, only 2 levels of details...
    if (!isEmpty(error.errors)) {
      each(error.errors, (errorDetail) => {
        // Set type to warning if RESOURCE_ALREADY_EXISTS
        if (errorDetail.code === 'RESOURCE_ALREADY_EXISTS') {
          errorType = 'warning'
          errorPrefix = '[WARN]'
        }

        let detail = errorDetail.message

        // Check if there is a detail for the detail...
        if (!isEmpty(errorDetail.errors)) {
          detail += ' ' + errorDetail.errors[0].message
        }

        // If RESOURCE_ALREADY_EXISTS, add "not updated" message
        if (errorDetail.code === 'RESOURCE_ALREADY_EXISTS') {
          detail += ' ' + upperFirst(i18next.t('dropzoneAsyncBulk:notUpdated'))
        }

        // Add details
        errorDetails.push(errorPrefix + ' ' + detail)
      })

      // Add processed error
      processedErrors.push({
        main: error.message,
        type: errorType,
        details: errorDetails
      })
    } else {
      // Add processed error
      processedErrors.push({
        main: errorPrefix + ' ' + error.message,
        type: errorType
      })
    }
  })

  return processedErrors
}

export default processErrors
